module.exports = __webpack_public_path__ + "static/media/logo_3.b8dd3000.png";